import React, { useCallback } from 'react';
import { block } from '../../utils';
import CircleProgress from './CircleProgress';
import './CustomBarControls.css';
const b = block('CustomBarControls');
const CustomBarControls = (props) => {
    const { mute, elapsedTimePercent = 0, className } = props;
    const renderMute = useCallback((elapsedTime, muteConfig) => {
        if (!muteConfig) {
            return null;
        }
        const { isMuted, changeMute } = muteConfig;
        return (React.createElement("div", { className: b('button'), onClick: changeMute },
            React.createElement("div", { className: b('mute-button', { muted: isMuted }) }),
            !isMuted && React.createElement(CircleProgress, { elapsedTime: elapsedTime, strokeWidth: 5 })));
    }, []);
    return React.createElement("div", { className: b('wrapper', className) }, renderMute(elapsedTimePercent, mute));
};
export default CustomBarControls;
